import './testAttachmentsViewComponent.scss'
import React from 'react';
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {CommonService} from "../../../../../shared/services";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import {Grid} from "@mui/material";

interface TestAttachmentsViewComponentProps {
    testAttachments: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const TestAttachmentsViewComponent = (props: TestAttachmentsViewComponentProps) => {
        const {testAttachments, onEditModeOpen, canEdit} = props;

        return (
            <div className="test-attachments-component details-tab-data-content">
                {
                    testAttachments?.length > 0 ? <>
                            <div className="details-tab-data-header">
                                <div className="view-and-edit-title">Attachments</div>
                            </div>
                            <div className="d-flex justify-content-space-between">
                                <div className={'details-tab-data-body view-details-attachment-chip-list'}>
                                    {testAttachments.map((attachment: any) => {
                                        return (
                                            <div key={CommonService.getUUID()}>
                                                <AttachmentViewDownloadComponent
                                                    attachment={attachment}
                                                    attachmentTitle={attachment.attachmentName}
                                                    showDeleteOption={false}
                                                />
                                            </div>
                                        )
                                    })}
                                </div>

                                {canEdit &&
                                    <div>
                                        <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            variant={"outlined"}
                                            startIcon={<EditIcon/>}
                                            fullWidth={true}
                                            handleClick={() => {
                                                onEditModeOpen()
                                            }}
                                        >
                                            Edit Details
                                        </ButtonComponent>
                                    </div>
                                }
                            </div>
                        </> :
                        <div className="no-attachments-wrapper">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <div className='no-attachments-header'>
                                        No attachments to show
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {
                                        canEdit &&
                                        <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            variant={"outlined"}
                                            fullWidth={true}
                                            handleClick={() => {
                                                onEditModeOpen()
                                            }}
                                        >
                                            Add Attachment
                                        </ButtonComponent>
                                    }
                                </Grid>
                            </Grid>
                        </div>
                }
            </div>
        )
    }

;

export default TestAttachmentsViewComponent;
